module.exports = __webpack_public_path__ + "img/generadordenotas.cfeda9e6.png";